import { SET_INTERFERENCE, SET_STRIPING } from 'Application/Store/Actions/CollisionTypes';
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';

export const OcclusionMapAndContactButtons = ({
    isInterferenceEnabled,
    isStripingEnabled,
    isStepEditMode,
    dispatch,
    computeAndDisplayTeethIntersection
}) => {
    const interferenceIsActive = isInterferenceEnabled;
    const stripingIsActive = isStripingEnabled;
    const interferenceLabel = interferenceIsActive
        ? ihm_viewer__dictionary.HIDE_INTERFERENCE[locale()]
        : ihm_viewer__dictionary.DISPLAY_INTERFERENCE[locale()];
    const stripingLabel = stripingIsActive
        ? ihm_viewer__dictionary.HIDE_STRIPPING[locale()]
        : ihm_viewer__dictionary.DISPLAY_STRIPPING[locale()];

    return (
        <div className="left-panel-buttons">
            <button
                className={`demi-collision-button ${interferenceIsActive ? "active" : ""}`}
                onClick={() => {
                    dispatch({
                        type: SET_INTERFERENCE,
                        payload: !interferenceIsActive,
                    });
                    computeAndDisplayTeethIntersection();
                }}
                disabled={isStepEditMode}
            >
                {interferenceLabel}
            </button>
            <button
                className={`demi-collision-button ${stripingIsActive ? "active" : ""}`}
                onClick={() => {
                    dispatch({
                        type: SET_STRIPING,
                        payload: !stripingIsActive,
                    });
                    computeAndDisplayTeethIntersection();
                }}
                disabled={isStepEditMode}
            >
                {stripingLabel}
            </button>
        </div>
    );
};
